const features = [
  {
    icon: 'ri-search-line',
    title: 'Curated Rentals',
    description: 'We handpick quality rental options that match your needs.',
  },
  {
    icon: 'ri-user-3-line',
    title: 'Tenant Support',
    description: "From shortlisting homes to scheduling visits, we guide you at every step.",
  },
  {
    icon: 'ri-home-4-line',
    title: 'Owner Solutions',
    description: 'We help owners find reliable tenants at a faster pace.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Trusted & Reliable',
    description: 'Clear communication and a safe, transparent process from start to finish.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="relative w-full bg-background-50 border-transparent sm:border-t sm:border-background-200/60">
      <div className="w-full px-4 py-5 sm:px-6 sm:py-10 md:px-12 md:py-14 lg:px-16 lg:pt-10">
        <div className="relative grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-0">
          {/* Subtle cross divider — mobile only */}
          <div className="block sm:hidden absolute inset-0 pointer-events-none z-0">
            <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-px bg-gradient-to-r from-transparent via-foreground-200/40 to-transparent" />
            <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px bg-gradient-to-b from-transparent via-foreground-200/40 to-transparent" />
          </div>
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`relative z-10 flex flex-col items-center text-center px-2.5 py-4 sm:px-5 sm:py-6 sm:rounded-none sm:bg-transparent sm:border-0 ${
                index < features.length - 1
                  ? 'lg:border-r lg:border-background-200/60'
                  : ''
              } ${
                index < 2 ? 'sm:border-r sm:border-background-200/60 lg:border-r' : ''
              }`}
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-2 sm:mb-3">
                <i className={`${feature.icon} text-xl sm:text-2xl text-foreground-800`} />
              </div>
              <h3 className="text-xs sm:text-sm md:text-base font-semibold text-foreground-950 sm:mb-1.5">
                {feature.title}
              </h3>
              <p className="hidden sm:block text-xs md:text-sm text-foreground-600 leading-relaxed max-w-xs">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}